import { lazy } from 'react';

/** Загружает раздел управления правами по требованию */
export const AccessManagementPageAsync = lazy(() => import('./AccessManagementPage'));
